import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

// material-ui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project imports
import Avatar from '@/components/@extended/Avatar';
import { PopupTransition } from '@/components/@extended/Transitions';
import { useAuthContext } from '@/providers';
import { getFirstAccessiblePath } from '@/menu-items/first-accessible-path';

// assets
import LockOutlined from '@ant-design/icons/LockOutlined';

// ==============================|| PERMISSION GATE - MODALĂ ACCES RESTRICȚIONAT ||============================== //

interface Props {
	open: boolean;
}

export const AccessDeniedModal: FC<Props> = ({ open }) => {
	const navigate = useNavigate();
	const { user, signOut } = useAuthContext();

	return (
		<Dialog
			open={open}
			keepMounted
			fullWidth
			maxWidth="xs"
			slots={{ transition: PopupTransition }}
			aria-labelledby="access-denied-title"
		>
			<DialogContent sx={{ p: 3 }}>
				<Stack sx={{ gap: 2.5, alignItems: 'center' }}>
					<Avatar color="error" sx={{ width: 64, height: 64, fontSize: '1.5rem' }}>
						<LockOutlined />
					</Avatar>
					<Stack sx={{ gap: 1 }}>
						<Typography
							variant="h4"
							sx={{ textAlign: 'center' }}
							id="access-denied-title"
						>
							Acces restricționat
						</Typography>
						<Typography sx={{ textAlign: 'center', color: 'text.secondary' }}>
							Nu ai permisiunile necesare pentru a accesa această pagină. Dacă crezi că
							este o eroare, contactează un administrator.
						</Typography>
					</Stack>
					<Stack direction="row" sx={{ gap: 1.5, width: 1, mt: 0.5 }}>
						<Button
							fullWidth
							color="secondary"
							variant="outlined"
							onClick={() => signOut()}
						>
							Deconectare
						</Button>
						<Button
							fullWidth
							variant="contained"
							onClick={() => navigate(getFirstAccessiblePath(user), { replace: true })}
							autoFocus
						>
							Spre pagina principală
						</Button>
					</Stack>
				</Stack>
			</DialogContent>
		</Dialog>
	);
};
